export * from '@firebase/functions';
//# sourceMappingURL=index.esm.js.map
